import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Demo',
    isLink: false,
  },
  {
    title: 'Set User',
    isLink: false,
  },
];

const Title: PageTitle = {
  title: 'User',
};

export { Breadcrumbs, Title };